(function () {
  var initializedSections = {};
  var MOBILE_BREAKPOINT = 749;

  function initFooterPhysics(sectionId) {
    if (initializedSections[sectionId]) return;
    if (typeof Matter === 'undefined') {
      setTimeout(function () { initFooterPhysics(sectionId); }, 50);
      return;
    }
    initializedSections[sectionId] = true;

    var footer = document.getElementById(sectionId);
    if (!footer) return;

    var layer = document.getElementById('physics-layer-' + sectionId.replace('section-', ''));
    var signupCard = document.getElementById('signup-card-' + sectionId.replace('section-', ''));
    var contactInfo = footer.querySelector('.custom-footer-info-grid');
    var stickerEls = Array.prototype.slice.call(footer.querySelectorAll('[data-sticker]'));

    if (!layer || stickerEls.length === 0) return;

    var Engine = Matter.Engine,
        Runner = Matter.Runner,
        World = Matter.World,
        Bodies = Matter.Bodies,
        Mouse = Matter.Mouse,
        MouseConstraint = Matter.MouseConstraint,
        Events = Matter.Events;

    var gravityStrength = parseFloat(footer.dataset.gravity || '60');
    var bounciness = parseFloat(footer.dataset.bounciness || '50');
    var mobileSpread = parseFloat(footer.dataset.mobileSpread || '260');

    var GRAVITY_Y = gravityStrength / 60;
    var RESTITUTION = bounciness / 100;
    var FRICTION = 0.15;
    var DENSITY = 0.002;

    var engine, runner, stickerBodies = [];
    var started = false;

    function buildWorld() {
      var w = footer.clientWidth;
      var h = footer.clientHeight;
      var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      // On mobile, confine the physics "stage" to a narrower band centered
      // in the footer so stickers land close together instead of spreading
      // across the full width.
      var stageWidth = isMobile ? Math.min(mobileSpread, w - 20) : w;
      var stageOffsetX = (w - stageWidth) / 2;

      engine = Engine.create();
      engine.gravity.y = GRAVITY_Y;
      runner = Runner.create();

      var wallOpts = { isStatic: true, render: { visible: false } };
      var floor = Bodies.rectangle(w / 2, h + 25, w * 2, 50, wallOpts);
      // Ceiling sits well above the entrance-spawn zone (see startY below)
      // so falling-in stickers never collide with it on the way down —
      // it only stops an aggressive upward drag/fling from escaping into
      // the section above the footer.
      var ceiling = Bodies.rectangle(w / 2, -320, w * 2, 50, wallOpts);
      var leftWall = Bodies.rectangle(stageOffsetX - 25, h / 2, 50, h * 2, wallOpts);
      var rightWall = Bodies.rectangle(stageOffsetX + stageWidth + 25, h / 2, 50, h * 2, wallOpts);
      World.add(engine.world, [floor, ceiling, leftWall, rightWall]);

      var stickerSize = stickerEls[0].getBoundingClientRect().width || 90;
      var chamfer = Math.round(stickerSize * 0.18);

      var footerRect = footer.getBoundingClientRect();
      var cardBottomY = null;
      var cardLeftX = stageOffsetX;
      var cardRightX = stageOffsetX + stageWidth;

      if (signupCard) {
        var cardRect = signupCard.getBoundingClientRect();
        var cx = (cardRect.left - footerRect.left) + cardRect.width / 2;
        var cy = (cardRect.top - footerRect.top) + cardRect.height / 2;

        var obstacle = Bodies.rectangle(cx, cy, cardRect.width, cardRect.height, {
          isStatic: true,
          render: { visible: false }
        });
        World.add(engine.world, obstacle);

        cardBottomY = (cardRect.bottom - footerRect.top);
        cardLeftX = Math.max(stageOffsetX, cardRect.left - footerRect.left);
        cardRightX = Math.min(stageOffsetX + stageWidth, cardRect.right - footerRect.left);
      }

      // Static collision body over the contact info (email/privacy policy
      // row), so stickers physically bounce off that zone instead of
      // resting on top of it and blocking clicks on the links underneath.
      if (contactInfo) {
        var infoRect = contactInfo.getBoundingClientRect();
        var icx = (infoRect.left - footerRect.left) + infoRect.width / 2;
        var icy = (infoRect.top - footerRect.top) + infoRect.height / 2;

        var infoObstacle = Bodies.rectangle(icx, icy, infoRect.width, infoRect.height, {
          isStatic: true,
          render: { visible: false }
        });
        World.add(engine.world, infoObstacle);
      }

      stickerBodies = stickerEls.map(function (el) {
        var startX, startY;

        if (cardBottomY !== null) {
          var minX = Math.max(cardLeftX, stageOffsetX + stickerSize / 2 + 10);
          var maxX = Math.min(cardRightX, stageOffsetX + stageWidth - stickerSize / 2 - 10);
          startX = minX + Math.random() * Math.max(maxX - minX, 10);
          startY = cardBottomY + 20 - Math.random() * 150;
        } else {
          var innerMin = stageOffsetX + stickerSize / 2 + 10;
          var innerMax = stageOffsetX + stageWidth - stickerSize / 2 - 10;
          startX = innerMin + Math.random() * Math.max(innerMax - innerMin, 10);
          // Spawn range trimmed to -50..-200 (was -100..-500) so every
          // sticker starts safely below the ceiling at -320 and has open
          // room to fall into view under gravity.
          startY = -50 - Math.random() * 150;
        }

        var angle = (Math.random() - 0.5) * 0.6;

        var body = Bodies.rectangle(startX, startY, stickerSize, stickerSize, {
          restitution: RESTITUTION,
          friction: FRICTION,
          density: DENSITY,
          angle: angle,
          chamfer: { radius: chamfer }
        });
        World.add(engine.world, body);
        return body;
      });

      var mouse = Mouse.create(layer);
      var mouseConstraint = MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: { stiffness: 0.2, render: { visible: false } }
      });
      World.add(engine.world, mouseConstraint);

      Runner.run(runner, engine);
      Events.on(engine, 'afterUpdate', syncPositions);
    }

    function syncPositions() {
      var half = (stickerEls[0].getBoundingClientRect().width || 90) / 2;
      stickerBodies.forEach(function (body, i) {
        var el = stickerEls[i];
        el.style.transform =
          'translate(' + (body.position.x - half) + 'px, ' + (body.position.y - half) + 'px) rotate(' + body.angle + 'rad)';
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !started) {
          started = true;
          buildWorld();
        }
      });
    }, { threshold: 0.2 });

    observer.observe(footer);
  }

  window.initFooterPhysics = initFooterPhysics;
  window.dispatchEvent(new Event('footer-physics:ready'));
})();